module.exports = __webpack_public_path__ + "Roboto-Thin.dfe56a876d0282555d1e.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Thin.eot
// module id = ../../../../../font/roboto/Roboto-Thin.eot
// module chunks = styles